import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ff0026}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"logo_horizontal\" transform=\"translate(143 208.025)\"><path id=\"Fill-33\" d=\"M-30.5-148.6 130.2-31.8 171.8-89 11.1-205.8z\" class=\"st0\"></path><path id=\"Fill-34\" d=\"M-124.7 29.3 67.2-22.1 48.9-90.4-143-39z\" class=\"st0\"></path><path id=\"Fill-35\" d=\"M-45.6 214 35.2 32.5-29.4 3.8l-80.8 181.4z\" class=\"st0\"></path><path id=\"Fill-36\" d=\"M147.4 269.6 57.2 92.7l-63 32.1 90.2 177z\" class=\"st0\"></path><path id=\"Fill-37\" d=\"m311.5 153.2-194.4-41.3-14.7 69.1 194.3 41.3z\" class=\"st0\"></path><path id=\"Fill-38\" d=\"m324.5-47.6-154.4 125 44.5 54.9L369 7.3z\" class=\"st0\"></path><path id=\"Fill-39\" d=\"M172.1 17.9h70.7v-198.7h-70.7z\" class=\"st0\"></path></g>", 1))
  ]))
}
export default { render: render }